import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Banner from '../../../components/Banner';
import Reaction from '../../../components/Reaction';
import Contact from '../../../components/Contact';
import LastUpdate from '../../../components/LastUpdate';

import DeailPermit1 from '../../../local-assets/faq-detail/detail-access-property-v1.png';
import DeailPermit2 from '../../../local-assets/faq-detail/detail-access-property-v2.png';


const FaqStrukReject = () => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

    return (
      <div className="bg-white min-h-screen  flex flex-col">
        <Navbar />
        <Banner
            image={process.env.REACT_APP_S3 + "banner_faq.png"} 
            beforePage="FAQ"
            currentPage="Detail FAQ" 
        />
        <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
            <div className="rounded-2xl md:rounded-3xl">
                <div className="mb-10 md:mb-16">
                    <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-6 leading-snug">
                        Kenapa saya tidak bisa mengakses kembali properti saya ?
                    </h1>
                    <label className="text-[#101828] text-md md:text-md">
                      Jika kamu tidak bisa lagi mengakses propertimu di summarecon home apps, itu berarti properti kamu sudah berstatus take out atau sudah tidak menjadi bagian Summarecon
                    </label>
                </div>
                <div className="flex flex-col gap-12 md:gap-20">
                  <div className="flex flex-col md:flex-row gap-8 md:gap-12">
                      <div className="w-full md:w-1/2 text-left justify-center md:justify-end">
                          <label className="mt-4 text-[#101828] text-lg md:text-lg font-bold">
                            Apa yang membuat hal ini terjadi ?
                          </label>
                          <ol className="list-decimal pl-5 mt-4 text-[#475467]">
                            <li className="mb-4">
                              Properti Anda mungkin tidak lagi termasuk dalam bagian Summarecon, sehingga fitur yang ada di aplikasi Summarecon tidak dapat lagi digunakan
                            </li>
                            <li className="mb-4">
                              Propertimu ter-take out karena sudah ada user lain yang mengambil alih kepemilikan properti kamu di Summarecon Home Apps, tetapi tenang saja kamu tetap bisa mengambil alih ulang propertimu loh
                            </li>
                          </ol>
                      </div>

                      {/* Kolom Kanan: Gambar */}
                      <div className="w-full md:w-1/2 flex justify-center md:justify-end">
                          {/* Box background hijau/abu-abu muda seperti di desain */}
                          <div className="rounded-3xl px-6 md:px-8 w-full max-w-[640px] flex justify-center items-center">
                              <img
                                  src={DeailPermit1}
                                  className="w-full h-auto object-contain drop-shadow-xl"
                              />
                          </div>
                      </div>
                  </div>
                  <div className="flex flex-col md:flex-row gap-8 md:gap-12">
                      <div className="w-full md:w-1/2 text-left justify-center md:justify-end">
                          <label className="mt-4 text-[#101828] text-lg md:text-lg font-bold">
                            Apa yang harus saya lakukan jika properti saya ter-take out ?
                          </label>
                          <label className="string mt-4 text-[#101828] text-md md:text-md font-bold">
                            Apa yang harus saya lakukan jika properti saya ter-take out ?
                          </label>
                          <ol className="list-decimal pl-5 mt-4 text-[#475467]">
                            <li className="mb-4">
                              Kamu bisa memvalidasikan ulang properti milikmu dengan mengupload sertifikat hak milik properti
                            </li>
                            <li className="mb-4">
                              Join family account dengan pemilik yang terdaftar
                            </li>
                          </ol>
                      </div>

                      {/* Kolom Kanan: Gambar */}
                      <div className="w-full md:w-1/2 flex justify-center md:justify-end">
                          {/* Box background hijau/abu-abu muda seperti di desain */}
                          <div className="rounded-3xl px-6 md:px-8 w-full max-w-[640px] flex justify-center items-center">
                              <img
                                  src={DeailPermit2}
                                  className="w-full h-auto object-contain drop-shadow-xl"
                              />
                          </div>
                      </div>
                  </div>
                </div>
                <LastUpdate/>
            </div>
        </div>
        <Contact />
        <Footer />
      </div>
    );
}

export default FaqStrukReject;